import React from 'react';
import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils';

import logo from './img/logo.png';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'cdv';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();
    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });


    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value,
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className="login-cdv-container text-align-center" ref={this.ref}>
          <div className="login-cdv-header" style={{ marginBottom: '40px' }}>
            <img src={logo} alt="logo" className="logo-cdv rounded mx-auto d-block" />
          </div>
          <div className="login-cdv-body">
            <div className="text-align-center" style={{ marginBottom: '20px' }}>
              <span className="cdv-title">Iniciar Sesión</span>
            </div>
            <Form onSubmit={event => this.onSubmit(event)}>
              <label style={{ fontSize: '16px' }}>Introduce tu correo electrónico</label>
              <input
                className="user-input-cdv"
                disabled={this.state.onLogin}
                ref={(ref) => this.usernameInput = ref}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
                placeholder="Correo Electrónico"
              />
              <label style={{ fontSize: '16px', marginTop: '5px' }}>Introduce tu contraseña</label>
              <input
                className="user-input-cdv"
                required={true}
                disabled={this.state.onLogin}
                ref={(ref) => this.passwordInput = ref}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
                placeholder="Contraseña"
              />
              {!this.state.onLogin ?
                <div className="row cdv-btns-row">
                  <div className="col-lg-2"></div>
                  <div className="col-xs-6 col-md-6 col-lg-4">
                    <div>
                      <button
                        block={!this.parameters.failureRedirect}
                        tabIndex={1}
                        className="enter-cdv"
                        type="submit"
                        name="submit"
                        disabled={!this.props.turnstileSuccess}
                      >
                        Ingresar
                      </button>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-6 col-lg-4">
                    <div className="btn-back-cdv">
                      <a href="#" >Cancelar</a>
                    </div>
                  </div>
                  <div className="col-lg-2"></div>
                </div>
                :
                <Progress animated color="danger" value={100} />}
              <div style={{ marginTop: '20px' }}>
                <p><a class="btn-link cdv-btn-forget" href="https://delvientotv.com.ar/acceso/cambiar_clave.php" target="_blank" rel="noopener noreferrer">Olvidé mi contraseña</a></p>
              </div>
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                  {this.state.error.message}
                </Alert>
              </div>
              <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
            </Form>
          </div>
          {
            checkDeviceIOS() ? '' : <div class="text-center">
              <p style={{ marginTop: '15px', color: 'white', fontSize: '16px' }}>Si aún no tenés un usuario en Del Viento TV, podés
                <a class="btn-link" href="https://delvientotv.com.ar/acceso/login.php" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'uppercase' }}> registrarte aquí</a>
              </p>
            </div>
          }
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true });
